import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'expiryDateFormatter',
    pure: true,
    standalone: false
})
export class ExpiryDateFormatterPipe implements PipeTransform {

  transform(value: any): any {
    let numChars = value.length;
    let thisVal;
    if(numChars === 2){
        thisVal = value;
        if(thisVal.includes('/')){
          value = '';
          return value
        }
        thisVal +=  '/';
        value = thisVal;
        return value
   }

  return value
}

}
